<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top" style="padding-top: 0;">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start">
                    <BankSelect :filterable="true" @onCnapsChanged="onCnapsChanged" />
                    <el-input style="margin-left: 10px; width: 28%" size="small" v-model="cnaps.cnapsCode" placeholder="或 输入联行号查询" />
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                </div>
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="cnapsList"
                    border stripe
                    :header-cell-style="{background:'#fafafa'}"
                    @cell-mouse-enter="handleCellEnter"
                    @cell-mouse-leave="handleCellLeave"
                    @cell-click="handleCellClick"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column prop="cnapsCode" label="联行号" width="110" align="center"></el-table-column>
                <el-table-column prop="cnapsName" label="联行名称" width="350" show-overflow-tooltip>
                    <template slot="header">
                        <el-tooltip effect="dark" placement="top">
                            <div slot="content" >
                                点击【联行名称】单元格可进行修改
                            </div>
                            <div class="yx-flex-h-center">
                                <span style=""><i class="el-icon-warning" style="color: orange;"/> 联行名称</span>
                            </div>
                        </el-tooltip>
                    </template>
                    <div class="item" slot-scope="scope">
                        <div class="item__input" >
                            <el-input v-model="cnapsNameTemp" placeholder="请输入联行/支行名称"></el-input>
                            <el-tag slot="reference" class="cls-tag3btn" type="success" effect="dark" @click="saveData(scope.row)" style="margin-left: 5px; ">
                                保存
                            </el-tag>
                        </div>
                        <div class="item__txt">{{scope.row.cnapsName}}</div>
                    </div>
                </el-table-column>
                <el-table-column prop="bankName" label="银行名称" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="provName" label="省份" width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cityName" label="城市" width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="areaName" label="区域" width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bankCode" label="银行代码" width="80" align="center"></el-table-column>
                <el-table-column prop="provCode" label="省份代码" width="80" align="center"></el-table-column>
                <el-table-column prop="cityCode" label="城市代码" width="80" align="center"></el-table-column>
                <el-table-column prop="bankType" label="行别编号 银盛" width="110" align="center"></el-table-column>
                <el-table-column prop="nuccOrgCode" label="nuccOrgCode" width="120" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="140"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" align="center" width="140"></el-table-column>
            </el-table>
        </div>
        <!-- 分页栏 -->
        <div class="yx-flex-h-end">
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>

    import {URL_BANK_CNAPS_LIST_PAGE, URL_BANK_CNAPS_UPDATE} from "../../../utils/cons";
    import BankSelect from "../../pub/BankSelect";

    export default {
        name: "Cnaps",
        components: { BankSelect },
        data() {
            return {
                cnapsNameTemp: null,
                cnapsCodeTemp: null,
                editProp: ['cnapsName'], // 需要编辑的属性
                clickCellMap: {}, // 保存进入编辑的cell
                preCell: null, // 前一个编辑的单元格对象
                saving: false, // 当前保存的编辑框
                cnapsList:[],
                cnaps:{
                    cnapsCode:null,
                    cnapsName:null,
                    bankCode:null,
                    bankName:null,
                    provCode:null,
                    provName:null,
                    cityCode:null,
                    cityName:null
                },
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                }
            }
        },
        watch: {
        },
        mounted() {
            this.initData();
        },
        methods: {
            /** 鼠标移入cell */
            handleCellEnter (row, column, cell, event) {
                const property = column.property
                if (property === 'cnapsName') {
                    cell.querySelector('.item__txt').classList.add('item__txt--hover')
                }
            },
            /** 鼠标移出cell */
            handleCellLeave (row, column, cell, event) {
                const property = column.property
                if (this.editProp.includes(property)) {
                    cell.querySelector('.item__txt').classList.remove('item__txt--hover')
                }
            },
            /** 点击cell */
            handleCellClick (row, column, cell, event) {
                const isCnapsNameCell = (column.property === 'cnapsName')
                // console.log("handleCellClick")
                /** 取消前一个单元格编辑状态 */
                if (this.preCell) {
                    this.cancelEditable(this.preCell)
                }

                if (this.saving) {
                    // console.log("saving", cell)
                    return
                }

                if (isCnapsNameCell) {
                    if (this.preCell) {
                        if (this.preCell !== cell)  {
                            this.cnapsNameTemp = row.cnapsName
                            this.cnapsCodeTemp = row.cnapsCode
                        }
                    } else {
                        this.cnapsNameTemp = row.cnapsName
                        this.cnapsCodeTemp = row.cnapsCode
                    }
                }


                const property = column.property
                if (this.editProp.includes(property)) {
                    this.preCell = cell
                    // 保存cell
                    this.saveCellClick(row, cell)
                    cell.querySelector('.item__txt').style.display = 'none'
                    cell.querySelector('.item__input').style.display = 'block'
                    cell.querySelector('input').focus()
                }
            },
            /** 取消编辑状态 */
            cancelEditable (cell) {
                // console.log("cancelEditable")
                cell.querySelector('.item__txt').style.display = 'block'
                cell.querySelector('.item__input').style.display = 'none'
            },
            /** 保存进入编辑的cell */
            saveCellClick (row, cell) {
                const id = row.id
                if (this.clickCellMap[id] !== undefined) {
                    if (!this.clickCellMap[id].includes(cell)) {
                        this.clickCellMap[id].push(cell)
                    }
                } else {
                    this.clickCellMap[id] = [cell]
                }
            },
            /** 保存数据 */
            saveData (row) {
                // console.log("saveData")

                this.$confirm( '【' + row.cnapsName + '】修改为【'+ this.cnapsNameTemp + '】' , '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.loading = true;
                    this.saving = true
                    const id = row.id
                    // 取消本行所有cell的编辑状态
                    this.clickCellMap[id].forEach(cell => {
                        this.cancelEditable(cell)
                    })
                    this.clickCellMap[id] = []

                    this.putRequest(URL_BANK_CNAPS_UPDATE, {
                        cnapsName: this.cnapsNameTemp,
                        cnapsCode: this.cnapsCodeTemp
                    }).then(resp => {
                        this.saving = false
                        this.loading = false;
                        if (resp) {
                            row.cnapsName = this.cnapsNameTemp
                        }
                    })
                }).catch(() => {
                });

            },
            onCnapsChanged(cnaps) {
                this.cnaps = cnaps
                // console.log(JSON.stringify(cnaps))
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initData();
            },
            initData() {
                this.loading = true;
                let url = URL_BANK_CNAPS_LIST_PAGE + '?page=' + this.page + '&size=' + this.size;
                if (this.cnaps) {
                    if (this.cnaps.provCode) url += '&provCode=' + this.cnaps.provCode;
                    if (this.cnaps.cityCode) url += '&cityCode=' + this.cnaps.cityCode;
                    if (this.cnaps.bankCode) url += '&bankCode=' + this.cnaps.bankCode;
                    if (this.cnaps.cnapsCode) url += '&cnapsCode=' + this.cnaps.cnapsCode;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.cnapsList = resp.data;
                        this.total = resp.total;
                        this.cnapsList.forEach((item, index, arr) => {
                            arr[index].isEdit = false
                        })
                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initData();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initData();
            }
        }

    }
</script>

<style lang="less"  scoped>
        .item {
            .item__input {
                width: 80%;
                display: none;
                /* 调整elementUI中样式 如果不需要调整请忽略 */
                :deep(.el-input__inner) {
                    height: 24px;
                }
                /* 调整elementUI中样式 如果不需要调整请忽略 */
                :deep(.el-input__suffix) {
                    i {
                        font-size: 12px;
                        line-height: 26px;
                    }
                }
            }
            .item__txt {
                width: 100%;
                box-sizing: border-box;
                border: 1px solid transparent;
                line-height: 24px;
                padding: 0 8px;
            }
            .item__txt--hover {
                width: 100%;
                border: 1px solid #dddddd;
                border-radius: 4px;
                cursor: text;
            }
    }
</style>
